import React, { useRef, useState } from 'react';
import './start.css';

import video from '../assets/PixVerse_V6_Image_Text_360P_ANIMATE_IT_MAKE_TH.mp4';

import startSound from '../audios/start.wav';
import levelsSound from '../audios/levels.wav';

import { useNavigate } from 'react-router-dom';
import { useMusic } from '../components/common/music';

const Start = () => {
  const navigate = useNavigate();

  const { playMusic } = useMusic();

  const [showMenu, setShowMenu] = useState(false);
  const [showAudioPopup, setShowAudioPopup] = useState(false);

  const startAudio = useRef(new Audio(startSound));
  const clickAudio = useRef(new Audio(levelsSound));

  const playStartSound = () => {
    startAudio.current.currentTime = 0;
    startAudio.current.play().catch(() => {});
  };

  const playClickSound = () => {
    clickAudio.current.currentTime = 0;
    clickAudio.current.play().catch(() => {});
  };

  const enableAudio = () => {
    playMusic();
    setShowAudioPopup(false);
    setShowMenu(true);
  };

  const disableAudio = () => {
    setShowAudioPopup(false);
    setShowMenu(true);
  };

  return (
    <section className='section1'>

      <video
        className="video1"
        autoPlay
        muted
        onEnded={() => setShowAudioPopup(true)}
      >
        <source src={video} type="video/mp4" />
      </video>

      <div className="overlay"></div>

      <div className={`title ${showMenu ? 'titleShow' : ''}`}>
        <h1 className="hoteltitlee">
          MYSTERY HOTEL
        </h1>
      </div>

      <div className={`splashdiv ${showMenu ? 'showSplash' : ''}`}>

        <div className='playbtn'>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="325"
            height="172"
            viewBox="0 0 325 172"
            fill="none"
          >
            <g filter="url(#filter0_g_190_940)">
              <rect
                x="52.2793"
                y="52.2789"
                width="220.302"
                height="66.6556"
                fill="#2C0309"
              />
            </g>

            <defs>
              <filter
                id="filter0_g_190_940"
                x="0.000419617"
                y="5.34058e-05"
                width="324.86"
                height="171.213"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feTurbulence
                  type="fractalNoise"
                  baseFrequency="0.019128184765577316 0.019128184765577316"
                  numOctaves="3"
                  seed="8096"
                />
                <feDisplacementMap
                  in="shape"
                  scale="104.55775451660156"
                  xChannelSelector="R"
                  yChannelSelector="G"
                  result="displacedImage"
                />
                <feMerge>
                  <feMergeNode in="displacedImage" />
                </feMerge>
              </filter>
            </defs>

          </svg>

          <h2
            className='playtext'
            onClick={() => {
              playStartSound();
              navigate('/Charchter');
            }}
          >
            START
          </h2>

        </div>

        <div className='btnsdiv'>

          <h2
            className='btns btn1'
            onClick={() => {
              playClickSound();
              navigate('/Charchter');
            }}
          >
            LEVELS
          </h2>

        

          <h2
            className='btns btn3'
            onClick={() => {
              playClickSound();
              navigate('/options');
            }}
          >
            OPTIONS
          </h2>

          <h2
            className='btns btn4'
            onClick={() => {
              playClickSound();
              navigate('/endlessmode');
            }}
          >
            INFINITE LEVEL
          </h2>

        </div>

      </div>
      {showAudioPopup && (
        <div className="audiomodal">

          <div className="audiobox">

            <h2>ENABLE AUDIO?</h2>

            <p>
              For the best Mystery Hotel experience,
              play with sound enabled.
            </p>

            <div className="audiobtns">

              <button className="audioyes" onClick={enableAudio}>
                YES
              </button>

              <button className="audiono" onClick={disableAudio}>
                NO
              </button>

            </div>

          </div>

        </div>
      )}

    </section>
  );
};

export default Start;